<template>
  <div class="mode7-wrap">
    <HTxtBanner v-exposure="{ eid: `101_15_${curindex}_0` }" :data-id="`101_15_${curindex}_0`" />
  </div>
</template>

<script>
import HTxtBanner from "@/components/banner/h-txt-banner.vue";
export default {
  components: {
    HTxtBanner,
  },
  props: {
    item: {
      type: [Object],
      default: () => ({}),
    },
    skeletonLoading: {
      type: Boolean,
      default: true,
    },
    curindex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  watch: {},
  async created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.mode7-wrap {
  margin-top: 20px;
  position: relative;
}

@media (max-width: 768px) {
  .mode7-wrap {
    margin-top: 0px;
    padding: 0px;
  }
}
</style>
